import { render, staticRenderFns } from "./dangerousGoodsListAction.vue?vue&type=template&id=6f34eca9&scoped=true"
import script from "./dangerousGoodsListAction.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsListAction.vue?vue&type=script&lang=js"
import style0 from "./dangerousGoodsListAction.vue?vue&type=style&index=0&id=6f34eca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34eca9",
  null
  
)

export default component.exports